import React from "react";
import { Controller } from "react-hook-form";
import { Button, Typography, Box } from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { useTranslation } from "react-i18next";

const CustomFileField = ({ name, label, control, errors }) => {
  const { t } = useTranslation();
  const nameId = `${name}-input`;

  const nameSplit = name.split(".");
  let errorName = errors[name];
  if (nameSplit.length === 3 && Object.keys(errors).length !== 0) {
    errorName = errors[nameSplit[0]]?.[Number(nameSplit[1])]?.[nameSplit[2]];
  }

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={null}
      render={({ field }) => (
        <Box>
          <input
            type="file"
            id={nameId}
            style={{ display: "none" }}
            onChange={(e) => {
              const file = e.target.files?.[0] || null;
              field.onChange(file);
            }}
          />

          <label htmlFor={nameId}>
            <Button fullWidth variant="contained" component="span" startIcon={<UploadFileIcon />}>
              {label}
            </Button>
          </label>

          {/* Persisted filename */}
          {field.value && (
            <Typography variant="body2" sx={{ mt: 0.5 }}>
              Selected file: {field.value.name}
            </Typography>
          )}

          {errorName && (
            <Typography color="error" variant="caption">
              {errorName.message}
            </Typography>
          )}
        </Box>
      )}
    />
  );
};

export default CustomFileField;
